import { AdaBindMethodPipe } from '@adaptiva/core/common';
import { ButtonComponentModule } from '@adaptiva/widgets/button';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Vector2Component } from './vector2.component';

@NgModule({
	imports: [
		AdaBindMethodPipe,
		ButtonComponentModule,
		CommonModule,
		ContainerComponentModule,
		InputComponentModule,
		LabelComponentModule,
		TextComponentModule
	],
	declarations: [Vector2Component],
	exports: [Vector2Component]
})
export class Vector2ComponentModule {

}
